// Fixture set for the "polish-the-draft" scene. One finished report (a
// catalytic converter theft) at the top of the list, opened directly:
//  - a rough note in the third paragraph for Enhance Writing (`enhance`
//    returns the polished version for exactly that text),
//  - the reporting party's name misheard as "Vasques" through the whole
//    report for Find and Replace.
// `/api/proofread` is answered generically by handlers.ts (a small slip list).
import type { FixtureSet, FixtureCase } from "../types";
import base from "./firstNarrativeReport";

/** The scene's `startRoute` is `/cases/<this id>`. */
export const POLISH_CASE_ID = "c0000000-0000-4000-8000-000000000301";

/** The rough note the scene selects and enhances (one whole paragraph). */
export const ROUGH_NOTE =
  "got there and talked w/ the RP Vasques, said she parked it sat nite and it was real loud sunday morn, looked under and the cat was cut off. didnt see anybody, no cams on the street";

const ENHANCED_NOTE =
  "<p>Upon arrival I contacted the reporting party, Maria Vasques, who stated she parked her vehicle at her residence on Saturday night. On Sunday morning the engine was unusually loud, and when she looked underneath she saw that the catalytic converter had been cut off. She did not see anyone near the vehicle, and there are no surveillance cameras on the street.</p>";

const content = [
  "<h1>Theft of Catalytic Converter - 26-004162</h1>",
  "<p>On Sunday, October 25, 2026, at approximately 0930 hours, I, Officer J. Ramirez #406, was dispatched to 880 Alder Lane regarding a report of a stolen catalytic converter.</p>",
  `<p>${ROUGH_NOTE}</p>`,
  "<p>Vasques described her vehicle as a silver 2011 Toyota Prius registered in her name. She told me the converter was intact when she last drove the car on Friday afternoon, and she had no recent repairs or visitors who had access to it.</p>",
  "<p>I photographed the exposed exhaust pipe and the cut marks on both ends, and I collected a metal shaving from the pavement beneath the vehicle. Vasques estimated the replacement cost at $2,400.</p>",
  "<p>I gave Vasques the case number and the victim information pamphlet. No suspects have been identified. This case is forwarded to the Investigations Bureau for follow-up.</p>",
].join("");

const catalytic: FixtureCase = {
  row: {
    ...base.cases[0].row,
    id: POLISH_CASE_ID,
    caseNumber: "26-004162",
    incidentDate: "2026-10-25",
    incidentTime: "09:30:00",
    status: "active",
    content: { data: content },
    audioUrl: base.completion.audioUrl,
    createdAt: "2026-10-28T18:10:00.000Z",
    updatedAt: "2026-10-28T18:14:00.000Z",
    actions: 0,
  },
  score: { score: 88 },
  suggestions: [
    { content: "Record the vehicle's license plate number for the report.", priority: 1 },
    { content: "State the approximate time Vasques last saw the converter intact.", priority: 2 },
  ],
  files: [],
  transcription: base.completion.transcription,
};

const polishTheDraft: FixtureSet = {
  ...base,
  name: "polishTheDraft",
  cases: [catalytic, ...base.cases],
  enhance: (text) => (text.trim() === ROUGH_NOTE ? ENHANCED_NOTE : `<p>${text}</p>`),
};

export default polishTheDraft;
